// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3pazN","footer":"ReportModalFilter_footer__3Cyrf"};